// pdfGenerator.js
// Dependency:
// <script src="https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js"></script>

function toBase64WithSize(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";

    img.onload = function () {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;

      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);

      resolve({
        base64: canvas.toDataURL("image/png"),
        width: img.width,
        height: img.height
      });
    };

    img.onerror = reject;
    img.src = url;
  });
}

async function addWatermark(pdf, imageUrl) {
  const pageCount = pdf.getNumberOfPages();

  const { base64, width, height } = await toBase64WithSize(imageUrl);

  for (let i = 1; i <= pageCount; i++) {
    pdf.setPage(i);

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const scale = 0.2;
    const imgWidth = width * scale;
    const imgHeight = height * scale;

    const x = 120;
    const y = 180;

    const gState = new pdf.GState({ opacity: 0.10 });
    pdf.setGState(gState);

    pdf.addImage(
      base64,
      "PNG",
      x,
      y,
      imgWidth,
      imgHeight,
      undefined,
      "NONE",
    );

    pdf.setGState(new pdf.GState({ opacity: 1 }));
  }
}

const perfumeDetailsContent = [
  `We know that mantras inspired by the rays of planets are capable of improving human life. Surya Mantra collects the sun's rays around us and removes bad rays. Similarly, perfume absorbs the rays related to its planet from the sky and collects them around us and creates the aura of that planet which directly impacts us.`,
  `A perfume enhances the physical charm of the wearer and increases the power and reduces the malefic influence of planet with its mysterious powers. The flow of radiations emitted by planets in our body gets enhanced with the power of perfumes. Therefore, those planets which are auspicious in horoscope but lack strength can be strengthened by using perfumes. But contrary to this the perfume of inauspicious planets multiplies the malefic effects of such inauspicious planets. This is the reason because of which astrologers advise complete relinquishing of the perfumes of inauspicious planets in horoscope.`,
  `A planet is considered favorable when posited in Lagna, Trikona or Kendra or has the lordship of these houses. This is inauspicious if connected to Trik Bhava. The conjunction and aspect of friendly planets also enhances its auspiciousness. The lordship of a Badhak Bhava reduces its beneficence. In movable Lagnas 11th, in stationary Lagnas 9th and in dual Lagnas the 7th house is termed as Badhak Bhava. The placement of planets in their enemy sign or sign of debilitation also decreases their auspiciousness.`,
  `For any horoscope the perfume of Lagna lord is known as life perfume by applying which the user gets good results like attainment of good health, development of personality and enhancement of reputation. The perfume of 9th house lord is termed as lucky perfume by wearing which the development of destiny can be expected along with enhancement of status. Similarly the perfume of Yoga Karaka planet is Karaka perfume and has enough potential to give financial gains and progress in the task undertaken along with all round development.`,
  `For the gratification of various desires one might need to use more than one perfume. The detailed information about which perfume would yield what type of results in your horoscope has been given below. You can attain maximum success in life with right selection of perfume.`,
  `For attaining the auspiciousness of inauspicious planets in the horoscope the remedial measures like wearing of Rudraksha, Mantra chanting, donation of its Karaka article, Jal Visarjan and fasting etc. can be recommended. If for some reason you are incapable to apply the required perfume then wear the Rudrakshas or else increase the strength of the planet by Mantra chanting, donation or fasting. The desired benefits are obtained by applying the perfume of auspicious planet and by Jal Visarjan and donation of the article or grain of inauspicious planets.`
]

const perfumeSelectionContent = `
Perfumes are believed to enhance the benefic effects of planets in a native’s life. From a scientific perspective, perfumes are thought to absorb the cosmic rays of the associated planet and transmit them to the human body, thereby strengthening the planet’s influence. This is why perfumes are recommended only for planets that are benefic in the horoscope.

A planet is considered benefic if it is placed in or rules the Lagna, Trikona, or Kendra houses. A planet also becomes benefic when it is conjunct with or aspected by friendly planets. These factors collectively determine the suitability of a planet for perfume application and define its overall positive influence.

The table below describes the areas of life influenced by each planet along with their benefic strength expressed in percentage terms. It is recommended to apply perfumes based on your specific needs throughout life, without being concerned about planetary dashas or transits related to the planets mentioned here.`

async function generateKundliPDF({
  userName,
  tableData,
  detailedHTML
})
 {
  const { jsPDF } = window.jspdf;
  const pdf = new jsPDF('p', 'pt', 'a4');

  const PAGE_WIDTH = pdf.internal.pageSize.getWidth();
  const PAGE_HEIGHT = pdf.internal.pageSize.getHeight();

  const MARGIN_X = 40;
  let y = 60;

  /* -------------------- HELPERS -------------------- */

function addFooter() {
  const footerHeight = 55;
  const footerY = PAGE_HEIGHT - footerHeight;

  pdf.setFillColor(245, 245, 245);
  pdf.rect(0, footerY, PAGE_WIDTH, footerHeight, "F");

  pdf.setDrawColor(180, 180, 180);
  pdf.setLineWidth(0.5);
  pdf.line(35, footerY + 10, PAGE_WIDTH - 35, footerY + 10);

  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(11);
  pdf.setTextColor(40, 40, 40);

  pdf.text(
    "ASTROSCENT GLOBAL PRIVATE LIMITED",
    40,
    footerY + 25
  );

  // ===== Address =====
  pdf.setFont("helvetica", "normal");
  pdf.setFontSize(9);
  pdf.setTextColor(90, 90, 90);

  const address =
    "G 26, Middle Circle, Connaught Place, Central Delhi - 110001, Delhi";

  const addressLines = pdf.splitTextToSize(address, 220);

  pdf.text(addressLines, 40, footerY + 38);

  // ===== Right Side Contact =====
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(9);
  pdf.setTextColor(50, 50, 50);

  const rightX = PAGE_WIDTH - 180;

  pdf.text("CONTACT", rightX, footerY + 25);

  pdf.setFont("helvetica", "normal");
  pdf.setTextColor(90, 90, 90);

  pdf.text("TEL: +91 8588822204", rightX, footerY + 38);
  pdf.text("support@astroscent.com", rightX, footerY + 50);
}
  function addUserName() {
    pdf.setFont('arial');
    pdf.setFontSize(16);
    const w = pdf.getTextWidth(userName);
    pdf.text(userName, (PAGE_WIDTH - w) / 2, 35);
    y += 60;
  }

  function addCenteredHeading(text) {
  checkPageBreak(60);

  pdf.setFont('Times', 'bold');
  pdf.setFontSize(18);

  const w = pdf.getTextWidth(text);
  pdf.text(text, (PAGE_WIDTH - w) / 2, y);

  y += 30;
}

function addStaticContent(text, fontSize = 16) {
  pdf.setFont('Times', 'normal');
  pdf.setFontSize(fontSize);

  const lineHeight = fontSize + 4;
  const maxWidth = PAGE_WIDTH - MARGIN_X * 2;

  const lines = pdf.splitTextToSize(text, maxWidth);

  // ✅ reserve space BEFORE writing
  checkPageBreak(lines.length * lineHeight);

  pdf.text(lines, MARGIN_X, y);
  y += lines.length * lineHeight + 12;
}

function cleanText(text)
{
  return text
    // remove literal escape sequences
    .replace(/\\t/g, ' ')
    .replace(/\\r\\n|\\r|\\n/g, ' ')

    // remove real whitespace just in case
    .replace(/\t+/g, ' ')
    .replace(/\r\n|\r|\n/g, ' ')
    .replace(/\u00a0/g, ' ')

    // normalize spacing
    .replace(/\s{2,}/g, ' ')
    .trim();
}

  function addParagraph(text, size = 16) {
    pdf.setFont('Times', 'normal');
    pdf.setFontSize(size);
    const lines = pdf.splitTextToSize(cleanText(text), PAGE_WIDTH - MARGIN_X * 2);
    pdf.text(lines, MARGIN_X, y);
    y += lines.length * (size + 4);
  }

function checkPageBreak(extra = 60) {

  if (y + extra > PAGE_HEIGHT - 60) {
    addFooter();

    pdf.addPage();

    y = 60;

    addUserName();
  }
}

  /* -------------------- PAGE 1 -------------------- */

  addUserName();
  addCenteredHeading('Perfume Selection', 16);

  addParagraph(perfumeSelectionContent, 14);
  checkPageBreak(120);

  // ---- TABLE ----
  const colWidths = [120, 120, 100, 140];
  const startX = MARGIN_X;

  function drawRow(values, isHeader = false) {
    let x = startX;
    pdf.setFont('Times', isHeader ? 'bold' : 'normal');
    pdf.setFontSize(isHeader ? 14 : 12);

    values.forEach((val, i) => {
      pdf.text(String(val), x, y);
      x += colWidths[i];
    });

    y += isHeader ? 40 : 30;
  }

  y+=50
  drawRow(['Perfume', 'Planet', 'Power', 'Area'], true);

  tableData.forEach(row => {
    checkPageBreak(40);
    drawRow([row.Perfume, row.Planet, row.Power, row.Strength]);
  });

  /* -------------------- PAGE 2+ -------------------- */
  addFooter();
  pdf.addPage();
  y = 60;
  addUserName();
  addCenteredHeading('Detailed Analysis', 16);

  perfumeDetailsContent.forEach((ele)=>{
    addParagraph(ele,14);
  })
  const container = document.createElement('div');
  container.innerHTML = detailedHTML;

  container.childNodes.forEach(node => {
   if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'H5') {
    y+=20
  addCenteredHeading(node.innerText.trim());
}

    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.textContent.replace(/\s+/g, ' ').trim();
      if (text) {
        checkPageBreak(80);
        addParagraph(text, 14);
      }
    }

    if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'p') {
      const text = node.innerText.trim();
      if (text) {
        checkPageBreak(80);
        addParagraph(text, 14);
      }
    }
  });

  /* -------------------- OPEN PDF -------------------- */
  await addWatermark(
  pdf,
  "https://cdn.shopify.com/s/files/1/0722/2421/1112/files/black_logo.png?v=1778157308"
);

window.open(pdf.output('bloburl'), '_blank');
}

window.generateKundliPDF = generateKundliPDF;
